import React from 'react';
import { Container, Graphics } from '@pixi/react';

import MenuWrapper from '../../containers/common/menuWrapper';
import Notification from '../../containers/common/notification';
import MobileFooterContainer from '../../containers/mobile/footer';
import WinLineWrapper from '../../containers/common/winLineWrapper';
import FreeBetWrapper from '../../containers/common/freeBetWrapper';
import GameLogoWrapper from '../../containers/common/gameLogoWrapper';
import WinPopupWrapper from '../../containers/common/winPopupWrapper';
import InfoSectionContainer from '../../containers/common/infoWrapper';
import GameBoardWrapper from '../../containers/common/gameBoardWrapper';
import LobbyIconWrapper from '../../containers/common/lobbyIconWrapper';
import JackPotInfoWrapper from '../../containers/common/jackPotInfoWrapper';
import GameBackgroundWrapper from '../../containers/common/gameBackgroundWrapper';
// import TournamentIconWrapper from '../../containers/common/tournamentIconWrapper';
import ConnectionPopupWrapper from '../../containers/common/connectionPopupWrapper';
import Gamble from '../../components/common/gamble';
import JackpotScene from '../../components/common/jackpotScene';
import ScaleComponent from '../../components/mobile/scaleComponent';
import MobileGameLayer from '../../components/mobile/mobileGameLayer';
import MobileBigWinLayer from '../../components/mobile/mobileBigWinLayer';
import JackPotCongratsPopup from '../../components/common/jackpot/jackPotCongratsPopup';
import BoostedJackpotIcon from '../../components/common/boostedJackpotIcon';
import BoostedJackpot from '../../components/common/boostedJackpot';
import RePlayInfoIconWrapper from '../../containers/common/rePlayInfoIconWrapper';
import TournamentIconWrapper from '../../containers/common/tournamentIconWrapper';

function MobileView({
  setMask,
  reelContainerRef,
  winContainerRef,
  touchSpinScreenRef,
  reelContainerConfig,
  touchSpinScreenConfig,
}) {
  return (
    <>
      <GameBackgroundWrapper />
      <ScaleComponent isCenterHorizontal childrenDefaultWidth={540}>
        <GameBoardWrapper />
        <Container ref={reelContainerRef} {...reelContainerConfig}>
          <Graphics
            draw={(g) => {
              g.beginFill(0xff700b);
              g.drawRect(-50, -50, 512, 300);
            }}
            ref={(graphicsRef) => setMask(graphicsRef)}
          />
        </Container>
        <Container ref={touchSpinScreenRef} {...touchSpinScreenConfig}>
          <Graphics
            draw={(g) => {
              g.clear();
              g.alpha = 0;
              g.interactive = true;
              g.beginFill(0x030303);
              g.drawRect(-50, -36, 526, 297);
            }}
          />
        </Container>
        <GameLogoWrapper />
        <WinLineWrapper />
        <Container ref={winContainerRef} {...reelContainerConfig} />
      </ScaleComponent>
      <MobileBigWinLayer />
      <ScaleComponent isCenterHorizontal>
        <Graphics
          draw={(g) => {
            g.clear();
            g.alpha = 0;
            g.interactive = false;
            g.beginFill(0x030303);
            g.drawRect(0, 0, 520, 1);
          }}
        />
        <WinPopupWrapper />
        <MobileFooterContainer />
        <TournamentIconWrapper />
        <RePlayInfoIconWrapper />
        <Notification />
      </ScaleComponent>
      <LobbyIconWrapper />
      <MobileGameLayer />
      <ScaleComponent isCenterHorizontal>
        <Graphics
          draw={(g) => {
            g.clear();
            g.alpha = 0;
            g.interactive = false;
            g.beginFill(0x030303);
            g.drawRect(0, 0, 540, 1);
          }}
        />
        <BoostedJackpotIcon />
      </ScaleComponent>
      <ScaleComponent name='GameTopLayers' isCenterHorizontal>
        <Graphics
          draw={(g) => {
            g.clear();
            g.alpha = 0;
            g.interactive = false;
            g.beginFill(0x030303);
            g.drawRect(0, 0, 540, 1);
          }}
        />

        <JackPotInfoWrapper />
      </ScaleComponent>
      <ScaleComponent name='GameTopLayers' isCenterHorizontal>
        <Graphics
          draw={(g) => {
            g.clear();
            g.alpha = 0;
            g.interactive = false;
            g.beginFill(0x030303);
            g.drawRect(0, 0, 540, 1);
          }}
        />
        <Gamble />
        <FreeBetWrapper />
        <InfoSectionContainer />
        <MenuWrapper />
        <BoostedJackpot />
      </ScaleComponent>
      <JackPotCongratsPopup />
      <JackpotScene />
      <ConnectionPopupWrapper />
    </>
  );
}

export default MobileView;
